export const Todo = {
  Explanation: "explanation" as const,
  FilesToUpload: "filesToUpload" as const,
  PostWithoutPicture: "postWithoutPicture" as const,
  Type: "type" as const,
  Currency: "currency" as const,
  Receipt: "receipt" as const,
  IncomingInvoice: "incomingInvoice" as const,
  Other: "other" as const,
}

export const MissingDocumentOther = {
  Dimensions: "dimensions" as const,
}

export const Receipt = {
  Date: "date" as const,
  Category: "category" as const,
  CategoryType: "categoryType" as const,
  Persons: "persons" as const,
  Dimensions: "dimensions" as const,
  Intent: "intent" as const,
}

export const IncomingInvoice = {
  Category: "category" as const,
  Dimensions: "dimensions" as const,
  Periodisation: "periodisation" as const,
}

